<header>
  <!-- start navigation -->
  <nav class="navbar navbar-expand-lg header-transparent bg-transparent disable-fixed" data-header-hover="dark">
    <div class="container-fluid">
      <div class="col-auto col-lg-2">
        <a class="navbar-brand" routerLink="/">
          <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="default-logo">
          <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="alt-logo">
          <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="mobile-logo">
        </a>
      </div>
      <div class="col-auto col-lg-3 text-end lg-pe-0">
        <div class="header-icon">
          <a href="mailto:info&#64;veeduplan.in" class="text-white">info&#64;veeduplan.in</a>
          <div class="header-push-button hamburger-push-button icon sm-pe-15px" (click)="toggleMenu()">
            <div class="push-button" [class.active]="isMenuOpen">
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- end navigation -->
  
  <!-- start hamburger menu-->
  <div class="push-menu hamburger-nav header-dark hamburger-menu-half bg-dark-gray md-w-60 sm-w-100" 
       [class.show]="isMenuOpen"
       style="background-image: url(assets/images/demo-gym-and-fitness-menu-bg.jpg)">
    <span class="close-menu text-dark-gray bg-white" (click)="closeMenu()">
      <i class="fa-solid fa-xmark"></i>
    </span>
    <div class="d-flex flex-column justify-content-center h-100 ps-18 pb-12 xxl-p-12 sm-p-20px">
      <div class="hamburger-menu menu-list-wrapper w-80 lg-w-100 lg-no-margin sm-mt-auto sm-mb-auto" 
           data-scroll-options='{ "theme": "light" }'>
        <ul class="menu-item-list fw-500 p-0">
          <li class="menu-item"><a (click)="scrollToSection('home')" class="inner-link nav-link">Home</a></li>
          <li class="menu-item"><a (click)="scrollToSection('about')" class="inner-link nav-link">About</a></li>
          <li class="menu-item"><a (click)="scrollToSection('pricing')" class="inner-link nav-link">Pricing</a></li>
          <li class="menu-item"><a (click)="scrollToSection('expertise')" class="inner-link nav-link">Services</a></li>
          <li class="menu-item"><a (click)="scrollToSection('testimonial')" class="inner-link nav-link">Testimonial</a></li>
          <li class="menu-item"><a (click)="scrollToSection('contact')" class="inner-link nav-link">Contact</a></li>
        </ul>
      </div>
      <div class="w-90 xxl-w-100 d-none d-lg-inline-block">
        <div class="row row-cols-1 row-cols-xl-2 menu-address">
          <div class="col">
            <span class="text-white fs-16 ls-05px">Contact information</span>
            <div class="h-1px w-90 lg-w-100 bg-white-transparent-extra-light mt-15px mb-15px"></div>
            <p class="fs-15 lh-26 w-90 xl-w-100 text-white fw-300">Ramanathapuram – 623501, Tamil Nadu, India.</p>
          </div>
          <div class="col">
            <span class="text-white fs-16 ls-05px">Connect with us</span>
            <div class="h-1px w-90 xxl-w-100 bg-white-transparent-extra-light mt-15px mb-15px"></div>
            <p class="fs-15 lh-28 w-90 xxl-w-100 lg-mb-0 fw-300">
              <a href="mailto:info&#64;veeduplan.in" class="d-block text-white text-white-hover">info&#64;veeduplan.in</a>
              <a href="tel:919150238997" class="text-white text-white-hover">+91 9150238997</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--end hamburger menu -->
</header>

